import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Leftsidebarindustry from '../components/Leftsidebarindustry'
import Indusrtypagebanner from '../components/Indusrtypagebanner'
function Real_State_Sector() {
  return (
    <div>
        <Header/>
    <Indusrtypagebanner/>
               <div className="service-details-section sp1">
    <div className="container">
        <div className="row">
            <Leftsidebarindustry/>

            <div className="col-lg-8">
                <div className="service-main-content heading1 padding1">
                    <h2>Real Estate Sector</h2>
                    <div className="space16"></div>
                   
                    <div className="space32"></div>
                    <div className="img1">
                        <img src="assets/img/industry/Industry_Focus/Real_Estate_Sector.png" alt=""/>
                    </div>
                    <div className="space32"></div>
                  
                    <div className="space16"></div>
                     <p>The real estate sector requires a unique blend of market insight, negotiation skills, and customer trust. JBY Talent Acquisition & Management Private Limited offers end-to-end recruitment solutions for builders, developers, and real estate consultancies by providing trained professionals in roles such as property consultants, sales executives, site managers, legal advisors, and marketing specialists</p>
                     <div className="space32"></div>
                    <p>Our candidates are equipped to handle everything from property showings to regulatory paperwork and CRM systems. </p>
                    <div className="space32"></div>
                    <p>We understand the dynamic nature of the real estate market and ensure that your team is equipped to close deals faster, build strong client relationships, and drive revenue.
                    </p>
                    <div className="space32"></div>
                  
                                      <div className="space32"></div>
                 
                </div>
            </div>
        </div>
    </div>
</div>
        <Footer/>
      
    </div>
  )
}

export default Real_State_Sector
